<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped>
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-quota="{ value }">
      {{ value }}%
    </template>
    <template #column-key-ricavoName="{ value }">
      {{ null === value ? 'Tutti i ricavi' : value }}
    </template>
    <template #column-key-vat="{ value }">
      {{ value }}%
    </template>
    <template #column-key-ritenuta="{ value }">
      {{ value }}%
    </template>
    <template #column-key-dilazione="{ value }">
      {{ value * 30 }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.cogs.edit', params: { costId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'costi-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    costi: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'ricavoName', label: 'Ricavo collegato' },
        { key: 'quota', label: 'Quota proporzionale' },
        { key: 'begin', label: 'Primo costo' },
        { key: 'end', label: 'Ultimo costo' },

        { key: 'dilazione', label: 'GG Dilazione' },
        { key: 'ritenuta', label: 'Ritenuta fiscale' },
        { key: 'vat', label: 'Iva' },
      ];
    },
    tableRows () {
      return (this.costi || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
